import * as _LottieOptions from './LottieOptions';

export * from './Animation';

export const LottieOptions = {
  ..._LottieOptions,
};
